module.exports = __webpack_public_path__ + "static/img/body-bg2.15949ca0.png";